/* globals alert, console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Backbone = require('backbone'),
    jQuery = require('jquery'),
    _ = require('lodash'),
    //
    FilterSet = require('../models/filterSet'),
    user = require('../models/user'),
    configuration = require('../utilities/configuration'),
    EOL = null;

module.exports = Backbone.Collection.extend({
    model: FilterSet,
    //
    create: function (data) {
        const filterSet = new FilterSet();
        filterSet.save(data, {
            success: _.bind(function (model, response, options) {
                this.add(model);
            }, this),
            error: function (model, xhr, options) {
                alert('Unable to create filter set\n(' + xhr.responseJSON.message + ')');
            }
        });
    },
    initialize: function (options) {
        this.listenTo(user, 'change', _.bind(function () {
            if (user.isSignedIn()) {
                this.refresh();
            }
        }, this));
        this.refresh();
    },
    refresh: function () {
        const url = configuration.mockdata.filterSets ? '/mockdata/filterSets.json'  : configuration.apiUrlBase + 'filters';
        if (user.isSignedIn()) {
            this.fetch({
                headers: user.authorizationHeader('filterSets'),
                method: 'GET',
                reset: true,
                url: url
            });
        } else {
            // if we're not logged in, clear the collection.
            this.reset();
        }
    }
});
